import { render, staticRenderFns } from "./LayoutBody.vue?vue&type=template&id=3faaeb2e&scoped=true&"
import script from "./LayoutBody.vue?vue&type=script&lang=js&"
export * from "./LayoutBody.vue?vue&type=script&lang=js&"
import style0 from "./LayoutBody.vue?vue&type=style&index=0&id=3faaeb2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faaeb2e",
  null
  
)

export default component.exports